import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  configApiRef,
  createApiFactory,
  createApiRef,
  discoveryApiRef,
  oauthRequestApiRef,OpenIdConnectApi,ProfileInfoApi, BackstageIdentityApi, SessionApi,ApiRef
} from '@backstage/core-plugin-api';

import { OAuth2 } from '@backstage/core-app-api';


export const giteaAuthApiRef: ApiRef<
  OpenIdConnectApi & ProfileInfoApi & BackstageIdentityApi & SessionApi
> = createApiRef({
  id: 'auth.gitea',
});



export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),

  createApiFactory({
    api: giteaAuthApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      oauthRequestApi: oauthRequestApiRef,
      configApi: configApiRef,
    },
    factory: ({ discoveryApi, oauthRequestApi, configApi }) =>
      // delegate auth to the OAuth2 strategy
      OAuth2.create({
        configApi,
        discoveryApi,
        oauthRequestApi,
        provider: {
          // this value MUST be 'oidc'
          // it maps our Keycloak-branded sign-in provider onto Backstage's generic OIDC auth strategy
          id: 'oidc',
          title: 'gitea',
          icon: () => null,
        },
        environment: 'gitea',
        defaultScopes: ['openid', 'profile', 'email'],
        popupOptions: {
          // optional, used to customize sign-in window size
          size: {
            fullscreen: true,
          },
          /**
           * or specify popup width and height
           * size: {
              width: 1000,
              height: 1000,
            }
           */
        },
      }),
  }),

];


